import React, {useState, useEffect} from 'react'
import {Redirect} from 'react-router-dom'
import queryString from 'query-string'
import {Button, Typography, FormHelperText, Grid, Link} from '@material-ui/core/'
import ReactSelect from '../../components/ReactSelect'
import {useFormReducerHook} from '../../utils/customHooks'
import {useSettings} from '../../utils/Settings'
import FormBuilder from '../../components/FormBuilder'
import Loader from '../../components/Loader'
import {
    getVerifyMember,
    getOuterAuthenticate,
    getValidateSession,
} from '../../services/outReach'
import ResetPassword from '../../containers/ResetPassword'
import Cookies from 'js-cookie'
import {ArrowBack} from '@material-ui/icons'
import MarkdownRender from '../../components/MarkdownRender'

const BackEnd = props => {
    const {
        formData,
        updateFormData: setFormData,
        errorsData,
        updateValidationData,
        validate,
    } = useFormReducerHook()
    const {appConfig, login} = useSettings()
    const [updateError, setUpdateError] = useState('')
    const [loading, setLoading] = useState(false)
    const [loadingSelectedPractice, setLoadingSelectedPractice] = useState(false)
    const [aaopracticeselection, setAaopracticeselection] = useState(false)
    let localStorageObj = undefined
    if (localStorage.getItem('association')) {
        const params = queryString.parse(props.location.search)
        if (
            params.id === undefined &&
            params.api === undefined &&
            params.checkmembertype === undefined &&
            params.saml === undefined
        ) {
            const {loginname, memberid} = queryString.parse(props.location.search)
            localStorageObj = {
                ...JSON.parse(localStorage.getItem('association')),
                loginname,
            }
            if (memberid) localStorageObj['memberid'] = memberid
            localStorage.removeItem('association')
            Cookies.remove('enrollment')
        }
    }
    const [queryParams] = useState(
        localStorageObj || queryString.parse(props.location.search)
    )
    const [redirect, setRedirect] = useState(false)
    const [data, setData] = useState([])
    const [selectedOption, setSelectedOption] = useState({})
    const [selectedOptionError, setSelectedOptionError] = useState('')
    const [resetpassword, setResetPassword] = useState(false)
    const [loginAPI, setLogin] = useState(false)
    const [outerAuthLoader, setOuterAuthLoader] = useState(false)

    if (
        Object.keys(queryParams).length > 0 &&
        redirect === false &&
        queryParams.id === undefined &&
        queryParams.api === undefined &&
        queryParams.checkmembertype === undefined &&
        queryParams.saml === undefined
    ) {
        setRedirect(true)
    }
    if (queryParams.id && resetpassword === false) {
        setResetPassword(true)
    }
    if (queryParams.saml === 'true') {
        const backup = {...queryParams}
        delete backup['saml']
        localStorage.setItem('association', JSON.stringify(backup))
        const callAPI = async () => {
            if (outerAuthLoader === false) setOuterAuthLoader(true)
            const result = await getOuterAuthenticate({associationdetails: backup})
            if (result.success.url) {
                window.location.assign(result.success.url)
            }
        }
        callAPI()
    }
    if (queryParams.api === 'true') {
        const backup = {...queryParams}
        delete backup['api']
        localStorage.setItem('association', JSON.stringify(backup))
        Cookies.set('enrollment', backup, {expires: 60})
        if (!loginAPI) setLogin(true)
    }

    const actionMethods = (type, payload) => {
        switch (type) {
            case 'enterOnKeyUp':
                submitForm()
                break
            default:
                break
        }
    }

    const submitForm = async () => {
        if (validate()) {
            setLoading(true)

            if (formData.ismember) {
                if (formData.ismember.value === 'false') {
                    const backup = {...queryParams}
                    delete backup['checkmembertype']
                    redirectToRegistration(backup)
                } else {
                    const backup = {...queryParams}
                    delete backup['checkmembertype']
                    backup['ismember'] = 'true'
                    localStorage.setItem('association', JSON.stringify(backup))

                    const callAPI = async () => {
                        const result = await getOuterAuthenticate({
                            associationdetails: backup,
                        })
                        if (result.success.url) {
                            window.location.assign(result.success.url)
                        }
                    }
                    callAPI()
                }
            } else {
                const response = await getVerifyMember(formData)
                if (Object.keys(response.error).length > 0) {
                    setUpdateError(response.error.message)
                    setLoading(false)
                } else {
                    setLoading(false)
                    if (response.success.practicedetails) {
                        //remove AAO for single practice skip practice selection
                        // if (response.success.practicedetails.length === 1) {
                        //     redirectToRegistration(response.success.practicedetails[0])
                        //     return
                        // }
                        const newdata = []
                        response.success.practicedetails.map(item => {
                            newdata.push({
                                value: item.practicename,
                                label: item.memberid + ' - ' + item.practicename,
                                obj: {
                                    value: item.practicename,
                                    label: item.memberid + ' - ' + item.practicename,
                                    ...item,
                                },
                            })
                        })
                        setData(newdata)
                        setAaopracticeselection(true)
                    } else {
                        redirectToRegistration(formData)
                    }
                }
            }
        }
    }

    const submitSeletedPractice = async () => {
        if (Object.keys(selectedOption).length !== 0) {
            setLoadingSelectedPractice(true)
            // const newObj = selectedOption
            // delete newObj['label']
            // delete newObj['value']
            // redirectToRegistration(newObj)
            const formData = {academyid: selectedOption.memberid, ismemberoforg: 1}
            const response = await getVerifyMember(formData)
            setLoadingSelectedPractice(false)
            if (Object.keys(response.error).length > 0) {
                setSelectedOptionError(response.error.message)
                // setLoading(false)
            } else {
                // setLoading(false)
                if (response.success.practicedetails) {
                    redirectToRegistration(response.success.practicedetails[0])
                }
            }
        } else {
            setSelectedOptionError(
                appConfig.supportedLabels.registration.selectPracticeRequiredError
            )
        }
    }

    const redirectToRegistration = input => {
        const URL2 = Object.keys(input).length > 0 ? '?' + objectToQueryString(input) : ''
        const URL =
            window.location.href.substring(0, window.location.href.indexOf('?')) + URL2
        window.location.assign(URL)
    }
    const objectToQueryString = obj => {
        let url = ''
        Object.keys(obj).forEach(key => {
            if (typeof obj[key] == 'object')
                url = url + key + '=' + encodeURIComponent(JSON.stringify(obj[key])) + '&'
            else url = url + key + '=' + encodeURIComponent(obj[key]) + '&'
        })
        url = url.substr(0, url.length - 1)
        return url
    }

    const handleResetPassword = () => {
        const callAPI = async () => {
            const result = await getValidateSession(queryParams.continuetoken)
            if (result.ispasswordreset) login()
        }
        callAPI()
    }

    const back_aaopracticeselection = () => {
        setSelectedOption({})
        setAaopracticeselection(false)
    }

    const loginPath =
        process.env.REACT_APP_ISMYACCOUNT === 'yes' ? '/login-my-account' : '/login'
    if (redirect && queryParams.interest) return <div>Interest already placed</div>
    if (redirect) return <Redirect to={{pathname: '/', state: queryParams}} />
    if (loginAPI) return <Redirect to={{pathname: loginPath}} />

    if (outerAuthLoader)
        return (
            <React.Fragment>
                {appConfig.supportedLabels.login.SAMLEnabledLoadingMessage}
                <Loader type="page" />
            </React.Fragment>
        )
    if (resetpassword)
        return (
            <React.Fragment>
                <ResetPassword onResetSuccess={handleResetPassword} />
            </React.Fragment>
        )
    if (aaopracticeselection)
        return (
            <React.Fragment>
                <Grid item className="login__contanier  signup-registration__form">
                    <Grid item className="login__head">
                        <Typography variant="h5" className="login__title" component="h3">
                            <Link
                                onClick={() => {
                                    setUpdateError('')
                                    setSelectedOptionError('')
                                    back_aaopracticeselection()
                                }}
                                style={{cursor: 'pointer', textDecoration: 'none'}}
                            >
                                <ArrowBack name="arrow left" size="large" />{' '}
                            </Link>
                            {appConfig.supportedLabels.registration.seletePracticeHeading}
                        </Typography>
                    </Grid>
                    <Grid item className="login__signin">
                        <ReactSelect
                            {...appConfig.practiceSelectProps}
                            data={data}
                            fieldValue={selectedOption}
                            onChange={item => {
                                setSelectedOptionError('')
                                setSelectedOption(item)
                            }}
                            errorText={selectedOptionError}
                        />
                        <MarkdownRender
                            value={appConfig.practiceSelectProps.noteForNoPractice}
                        />
                    </Grid>
                    <Grid item xs className="login__form-action">
                        <Grid item xs={12} className="loader__container">
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={submitSeletedPractice}
                                disabled={loadingSelectedPractice}
                            >
                                {
                                    appConfig.supportedLabels.registration
                                        .selectPracticeBtnTxt
                                }
                            </Button>

                            {loadingSelectedPractice ? <Loader /> : null}
                        </Grid>
                    </Grid>
                </Grid>
            </React.Fragment>
        )
    if (appConfig.registrationFormProps)
        return (
            <React.Fragment>
                <Grid item className="login__contanier  signup-registration__form">
                    <Grid item className="login__signin">
                        <FormBuilder
                            fields={appConfig.registrationFormProps}
                            formData={formData}
                            setFormData={setFormData}
                            errorsData={errorsData}
                            updateValidation={updateValidationData}
                            onSubmit={submitForm}
                            actionMethods={actionMethods}
                        />
                        <FormHelperText error>{updateError}</FormHelperText>
                    </Grid>
                    <Grid item xs className="login__form-action">
                        <Grid item xs={12} className="loader__container">
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    setUpdateError('')
                                    submitForm()
                                }}
                                disabled={loading}
                            >
                                {appConfig.supportedLabels.registration.submitBtnTxt}
                            </Button>
                            {loading ? <Loader /> : null}
                        </Grid>
                    </Grid>
                    {appConfig.customization.hideloginlink ? null : (
                        <Grid item xs className="login__form-bottom-action">
                            <span>
                                {appConfig.supportedLabels.signup.alreadyHaveAccountTxt}{' '}
                            </span>{' '}
                            <Link to={loginPath}>
                                <Button
                                    onClick={() => {
                                        setLogin(true)
                                    }}
                                    color="primary"
                                >
                                    {' '}
                                    {appConfig.supportedLabels.signup.loginBtnTxt}{' '}
                                </Button>
                            </Link>
                        </Grid>
                    )}
                </Grid>
            </React.Fragment>
        )
    if (redirect && appConfig.preVerificationRequired === undefined)
        return <Redirect to={{pathname: '/'}} />

    if (appConfig.preVerificationMessage)
        return <MarkdownRender value={appConfig.preVerificationMessage} />

    return <div>Unauthorized: Access to this resource is denied</div>
}

export default BackEnd
